import { USER_REFRESH_TOKEN_KEY, USER_TOKEN_KEY } from '../const/localstorage'

export const saveAuthTokens = (accessToken: string, refreshToken: string) => {
    localStorage.setItem(USER_TOKEN_KEY, accessToken)
    localStorage.setItem(USER_REFRESH_TOKEN_KEY, refreshToken)
}

export const clearAuthTokens = () => {
    localStorage.removeItem(USER_TOKEN_KEY)
    localStorage.removeItem(USER_REFRESH_TOKEN_KEY)
}
